import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [user, setUser] = useState(null); // { name, email }
    const [activeBusinessId, setActiveBusinessId] = useState(1);

    // Dummy Data that acts as "Database"
    const [businesses, setBusinesses] = useState([
        {
            id: 1,
            name: "EcoLogistics",
            tagline: "Sustainable supply chain AI",
            stage: "Growth",
            revenue: "$12,500",
            demand: 88,
            tasks: [
                { id: 1, title: "Update Privacy Policy", status: "todo" },
                { id: 2, title: "Q3 Financial Review", status: "done" }
            ]
        }
    ]);

    const login = (email) => setUser({ name: "Alex Founder", email });
    const logout = () => setUser(null);

    // The Magic Function: Adds a new business from the Builder
    const createBusiness = (bizData) => {
        const newBiz = {
            id: Date.now(),
            ...bizData,
            revenue: "$0",
            stage: "Idea",
            tasks: [
                { id: 1, title: "Register Domain Name", status: "todo" },
                { id: 2, title: "Setup Stripe Account", status: "todo" }
            ]
        };
        setBusinesses([...businesses, newBiz]);
        return newBiz.id;
    };

    const getActiveBusiness = () => businesses.find(b => b.id === activeBusinessId) || businesses[0];

    return (
        <AppContext.Provider value={{
            user, login, logout,
            businesses, createBusiness,
            activeBusinessId, setActiveBusinessId, getActiveBusiness
        }}>
            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => useContext(AppContext);
